module.exports = __webpack_public_path__ + "img/mail.f5af2752.png";